import axios from 'lib/axios'

export const getDataFormInstance = (formId) => axios.get(`/forms/v3/instance/${formId}/data`)

export const postDataFormInstance = (formId, data) => axios.put(`/forms/v3/instance/${formId}/data`, data)

export const postQuestionnairePrice = (hashId, data) =>
  axios.post(`/questionnaire_requests/${hashId}/set_questionnaire_price`, data)

export const postQuestionnaireArchive = (hashId, purchaserToken) =>
  axios.post(`/questionnaire/${hashId}/archive_questionnaire/${purchaserToken}`)

export const postQuestionnaireUnArchive = (hashId, purchaserToken) =>
  axios.post(`/questionnaire/${hashId}/unarchive_questionnaire/${purchaserToken}`)

export const postQuestionnaireCancel = (hashId) => axios.post(`/questionnaire/${hashId}/cancel`)

export const postQuestionnaireRequest = (hashId) =>
  axios.post(`/questionnaire_requests/${hashId}/send_completed_questionnaire_pdf`)

export const getQuestionnaireRequestPublicData = (hashId) => axios.get(`/questionnaire_requests/${hashId}/public_data`)
